import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Skeleton,
    useStyleConfig,
    VStack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useGlobaleContext} from '../../../contexts/globale'
import {formattedURL} from '../../../utils/url'
import DisplayPrice from '../../display-price'

export const ProductViewHeader = ({
    name,
    currency,
    priceData,
    globalePrices,
    promoId,
    product,
    isProductPartOfBundle,
    onTileClick,
    pwpTargetPromotionId
}) => {
    const styles = useStyleConfig('ProductViewCompactStyles')
    const {countryISO} = useGlobaleContext()
    const productUrl = product?.slugUrl
    const productUrlFormatted = formattedURL(productUrl)

    if (product && globalePrices && pwpTargetPromotionId) {
        const promoObj = globalePrices?.find((p) => p?.[pwpTargetPromotionId])?.[
            pwpTargetPromotionId
        ]
        priceData.currentPrice =
            promoObj?.[product?.master?.masterId] !== null
                ? promoObj?.[product?.master?.masterId]
                : product?.price || 0
        priceData.isOnSale = priceData.listPrice !== priceData.currentPrice
    }
    return (
        <VStack className="product-view-stack" {...styles.viewStack.body}>
            {/* Title */}
            <Skeleton isLoaded={name}>
                <Box
                    {...productUrlFormatted}
                    onClick={onTileClick}
                    className="product-name"
                    _hover={{
                        color: 'blue.700',
                        textDecoration: 'unset'
                    }}
                    {...styles.viewStack.productName}
                    pointerEvents={promoId ? 'none' : 'auto'}
                >
                    {name}
                </Box>
            </Skeleton>

            {!isProductPartOfBundle && (
                <>
                    <Skeleton isLoaded={priceData !== undefined && priceData !== null}>
                        {priceData && countryISO !== null && (
                            <DisplayPrice
                                priceData={priceData}
                                currency={product?.c_selectedCurrency || currency}
                                symbol={product?.c_selectedCurrencySymbol}
                            />
                        )}
                    </Skeleton>
                </>
            )}
        </VStack>
    )
}

ProductViewHeader.propTypes = {
    name: PropTypes.string,
    currency: PropTypes.string,
    globalePrices: PropTypes.any,
    promoId: PropTypes.any,
    category: PropTypes.array,
    priceData: PropTypes.object,
    product: PropTypes.object,
    isProductPartOfBundle: PropTypes.bool,
    showDescription: PropTypes.bool,
    onTileClick: PropTypes.func,
    pwpTargetPromotionId: PropTypes.string
}
